import * as React from 'react'
import PubData from './../../content/json-publicationslinks-fr.json'
import PictureAsPdfIconOutlined from '@mui/icons-material/PictureAsPdfOutlined'

const DownloadPub = ({ name, suffix }) => {
  return (
    <a
      className='download-button'
      href={PubData[name][1]}
      data-name={PubData[name][0]}
      target='_blank'
    >
      <PictureAsPdfIconOutlined> </PictureAsPdfIconOutlined> {suffix}{' '}
      {PubData[name][0]} <span className='arr'>→</span>
    </a>
  )
}

export default DownloadPub
